"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styledLayout_1 = require("../base/styledLayout");
exports.FormGroup = function (_a) {
    var _b;
    var children = _a.children, _c = _a.alignment, alignment = _c === void 0 ? 'horizontal' : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    var direction = alignment === 'vertical' ? "ty-flex-column" /* Column */ : "ty-flex-row" /* Row */;
    var groupClassName = classnames_1.default('ty-form-group', (_b = {},
        _b[className] = className,
        _b));
    return (React.createElement(styledLayout_1.StyledLayout, { elementType: "div" /* Div */, display: "ty-display-flex" /* Flex */, flexDirection: direction, className: groupClassName }, children));
};
